import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const useLocalStorage = () => {
	const vaxFormData = useSelector((state) => state.vaxFormData);
	const vaxFile = useSelector((state) => state.vaxFile);

	useEffect(() => {
		if (typeof window !== 'undefined') {
			localStorage.setItem('vaxFormData', JSON.stringify(vaxFormData));
			localStorage.setItem('vaxFile', JSON.stringify(vaxFile));
		}
	}, [vaxFormData, vaxFile]);
};

export default useLocalStorage;
